import { ApiService } from '../api.service';
import { Injectable } from '@angular/core';
import { Commande } from '../../models/Commande';

@Injectable({
  providedIn: 'root'
})
export class ClientsService {

  constructor(private api: ApiService) { }


  findByLogin2(login: any) {
    return this.api.get('/common/clients/search-by-login2?a=' + login);
  }

  findByLogin(login: any) {
    return this.api.get('/common/clients/search-by-login?a=' + login);
  }

  findByLoginOmy(login: any) {
    return this.api.get('/common/clients/search-by-login-omy?a=' + login);
  }
  findByLoginTelco(login: any) {
    return this.api.get('/common/clients/search-by-login-telco?a=' + login);
  }

  findAgents() {
    return this.api.get('/common/clients/agents');
  }

  findProduits() {
    return this.api.get('/common/clients/search-produits');
  }

  searchMsisdn(login: any) {
    return this.api.get('/common/clients/search-msisdn?a=' + login);
  }

  searchLastCommandes(login: any) {
    return this.api.get('/common/clients/search-last-commandes?a=' + login);
  }

  
}
//76137694;610025063887175;93826259;610025033625778


